module.exports = __webpack_public_path__ + "img/1639535776_300px.2e8351c4.png";